import * as React from 'react';
import {CommonHelpers, CustomProperty} from "@falcon/services";
import {Link} from "react-router-dom";
import NotificationModal from "../../../../../components/modals/NotificationModal";

interface IProps {
    properties: CustomProperty[] | undefined,
    coverCancelled: boolean,
    unpaidRenewal: boolean,
    interactionId: string
}

interface IState {
    showAlert: boolean
}

export class AdditionalPolicyholderDetailsWidget extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            showAlert: false
        }
    }

    public render(): React.ReactNode {
        const disableEdit: boolean = this.props.coverCancelled || this.props.unpaidRenewal;

        if (this.props.properties) {
            return (
                <>
                    <div className="section">
                        <div className="section-heading">Additional details</div>
                        <div className="section-contents">
                            {this.renderCustomProperty("ownsHome", "Has own home", false)}
                            {this.renderCustomProperty("carsInHousehold", "Cars in household", true)}
                            {this.renderCustomProperty("hasUnspentCriminalConvictions", "Criminal convictions (exluding motoring convictions)", false)}
                            {this.renderCustomProperty("customerLVMember", "LV= member", false)}
                            <div className="link-edit">
                                {/* TODO: The design of this journey is a bit shit as we need to pass interaction from one car if there are multiple cars insured
                                while in the end the journey updates all motor covers on the account. Leaving as is for now as the refactoring is taking up a lot of time as it is already*/}
                                <Link
                                    id={`editAdditionalDetails`}
                                    aria-label="Edit additional details"
                                    to={`/journey/show/product/MotorInsurance/process/mtaChangePolicyHolderAdditionalDetails/changePolicyHolderAdditionalDetailsPresetPage/${this.props.interactionId}`}
                                    className={disableEdit ? "disabled" : ""}
                                    onClick={(e) => {disableEdit ? this.handleClick(e) : e }}>
                                    Edit
                                </Link>
                            </div>
                        </div>
                    </div>
                    {this.renderAlert()}
                </>
            )
        } else {
            return <></>
        }
    }

    private renderCustomProperty(propertyKey: string, label: string, showActualValue: boolean): React.ReactNode {
        const filteredProperties: CustomProperty[] = this.props.properties!.filter(p => p.key === propertyKey);

        if (filteredProperties && filteredProperties.length !== 0) {
            const filteredProperty: CustomProperty = filteredProperties[0];
            let value: string;
            if (showActualValue) {
                value = filteredProperty.value;
            } else {
                value = CommonHelpers.booleanToText(filteredProperty.value, "Yes", "No");
            }

            return (
                <div className="detail">
                    <div className="detail-key">{label}</div>
                    <div className="detail-value">{value}</div>
                </div>
            )
        } else {
            return <></>
        }
    }

    private handleClick = (event: any): void => {
        event.preventDefault();

        this.setState({showAlert: true});
    };

    private hideAlert = () => {
        this.setState({showAlert: false});
    }

    private renderAlert(): React.ReactNode {
        const wording: string = this.props.coverCancelled ?
            "Due to policy cancellation this action is not allowed" :
            "This action is not allowed";

        return (
            <NotificationModal show={this.state.showAlert} hide={this.hideAlert}>
                {wording}
            </NotificationModal>
        )
    }
}
